import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"
import { PAGINATION_INITIAL_STATE } from "./constants"

// ============ LIST ============
const requested = createAction("discounts/requested")
const received = createAction("discounts/received")
const failed = createAction("discounts/failed")

// ============ CREATE ============
const requestedCreate = createAction("discounts/requestedCreate")
const receivedCreate = createAction("discounts/receivedCreate")
const failedCreate = createAction("discounts/failedCreate")

// ============ UPDATE ============
const requestedUpdate = createAction("discounts/requestedUpdate")
const receivedUpdate = createAction("discounts/receivedUpdate")
const failedUpdate = createAction("discounts/failedUpdate")

// ============ TOGGLE ============
const requestedToggle = createAction("discounts/requestedToggle")
const receivedToggle = createAction("discounts/receivedToggle")
const failedToggle = createAction("discounts/failedToggle")

// ============ DELETE ============
const requestedDelete = createAction("discounts/requestedDelete")
const receivedDelete = createAction("discounts/receivedDelete")
const failedDelete = createAction("discounts/failedDelete")

// ============ INITIAL STATE ============
const initialState = {
  ...LOADING_INITIAL_STATE,
  items: [],
  metadata: { ...PAGINATION_INITIAL_STATE },
  createDiscount: { ...LOADING_INITIAL_STATE },
  updateDiscount: { ...LOADING_INITIAL_STATE },
  toggleDiscount: { ...LOADING_INITIAL_STATE },
  deleteDiscount: { ...LOADING_INITIAL_STATE }
}

// ============ REDUCER ============
const discountsReducer = createReducer(initialState, {
  [requested.type]: (state) => { setRequested(state) },
  [received.type]: (state, { payload }) => {
    setReceived(state)
    state.items = payload.data || payload
    if (payload.metadata) Object.assign(state.metadata, payload.metadata)
  },
  [failed.type]: (state) => { setFailed(state) },

  [requestedCreate.type]: (state) => { setRequested(state.createDiscount) },
  [receivedCreate.type]: (state) => { setReceived(state.createDiscount) },
  [failedCreate.type]: (state) => { setFailed(state.createDiscount) },

  [requestedUpdate.type]: (state) => { setRequested(state.updateDiscount) },
  [receivedUpdate.type]: (state) => { setReceived(state.updateDiscount) },
  [failedUpdate.type]: (state) => { setFailed(state.updateDiscount) },

  [requestedToggle.type]: (state) => { setRequested(state.toggleDiscount) },
  [receivedToggle.type]: (state) => { setReceived(state.toggleDiscount) },
  [failedToggle.type]: (state) => { setFailed(state.toggleDiscount) },

  [requestedDelete.type]: (state) => { setRequested(state.deleteDiscount) },
  [receivedDelete.type]: (state) => { setReceived(state.deleteDiscount) },
  [failedDelete.type]: (state) => { setFailed(state.deleteDiscount) }
})

export default discountsReducer

// ============ API ACTIONS ============

export const getDiscounts = (params = {}) =>
  api({
    url: "/guide/settings/discounts",
    method: "get",
    params,
    onStart: requested.type,
    onSuccess: received.type,
    onError: failed.type
  })

export const createDiscount = (data) =>
  api({
    url: "/guide/settings/discounts",
    method: "post",
    data,
    onStart: requestedCreate.type,
    onSuccess: receivedCreate.type,
    onError: failedCreate.type,
    showSuccessNotification: true
  })

export const updateDiscount = (id, data) =>
  api({
    url: `/guide/settings/discounts/${id}`,
    method: "put",
    data,
    onStart: requestedUpdate.type,
    onSuccess: receivedUpdate.type,
    onError: failedUpdate.type,
    showSuccessNotification: true
  })

export const toggleDiscount = (id) =>
  api({
    url: `/guide/settings/discounts/${id}/toggle`,
    method: "put",
    onStart: requestedToggle.type,
    onSuccess: receivedToggle.type,
    onError: failedToggle.type,
    showSuccessNotification: true
  })

export const deleteDiscount = (id) =>
  api({
    url: `/guide/settings/discounts/${id}`,
    method: "delete",
    onStart: requestedDelete.type,
    onSuccess: receivedDelete.type,
    onError: failedDelete.type,
    props: { id },
    showSuccessNotification: true
  })

export const validateDiscount = (code, amount, experienceId, clientIdentifier) =>
  api({
    url: "/guide/settings/discounts/validate",
    method: "post",
    data: { code, amount, experience_id: experienceId, client_identifier: clientIdentifier },
    suppressErrorNotification: true
  })
